module.exports = __webpack_public_path__ + "static/media/eating-lunch.8e1cb489.svg";